<template>
  <div class="item-slot">
    <img loading="lazy" sizes="100%, 100%" class="icon-image" :class="{'default' : id === 0}" :src="selectedItemPreview"
         :alt="this.selectedItem.name"
         :title="this.selectedItem.name" @click="showItemSearch">
    <ItemSearch :items="items" ref="itemSearch" @selected="itemSelected"></ItemSearch>
  </div>
</template>

<script>
  import ItemSearch from "./ItemSearch";

  export default {
    name: "ItemSlot",
    components: {ItemSearch},
    props: {
      id: {
        type: Number,
        default: 0,
      },
        required: true,
        type: String,
      itemSlot: {
      },
      isBlowpipe: {
        type: Boolean,
        default: function() {
          return false;
        },
      }
    },
    data() {
      return {
        showSearch: false,
        originalItems: null,
        items: [],
        stats: {
          attack_stab: 0,
          attack_slash: 0,
          attack_crush: 0,
          attack_magic: 0,
          attack_ranged: 0,
          defence_stab: 0,
          defence_slash: 0,
          defence_crush: 0,
          defence_magic: 0,
          defence_ranged: 0,
          melee_strength: 0,
          ranged_strength: 0,
          magic_damage: 0,
        }
      }
    },
    computed: {
      selectedItemPreview: function () {
        if (this.selectedItem.icon === '' || this.selectedItem.icon === undefined) {
          return '/static/images/icons/equipment/none.png'
        }

        return `data:image/jpeg;base64,${this.selectedItem.icon}`
      },
      selectedItem: function () {
        if (this.items.length === 0)
          return {id: 0};

        return this.originalItems[this.id];
      },
      parsedItems: function () {
        return Object.keys(this.originalItems).filter((key) => {
          let item = this.originalItems[key];
          // console.log('parsedItems', [key, item]);

          if(this.isBlowpipe) {
            return item.equipable_by_player && !item.duplicate && item.name.indexOf('dart') !== -1;
          }

          return item.equipable_by_player && !item.duplicate;
        }).map((key) => {
          return this.originalItems[key];
        });
      },
    },
    methods: {
      loadItems: function () {
        if (this.itemSlot === 'weapon') {
          this.loadWeapons();
          return
        }

        this.$http.get(`https://www.osrsbox.com/osrsbox-db/items-json-slot/items-${this.itemSlot}.json`).then((resp) => {
          this.originalItems = resp.data;
          this.addEmptyItem();

          this.items = this.parsedItems
        })
      },

      loadWeapons: function () {
        let oneHanded = this.$http.get(`https://www.osrsbox.com/osrsbox-db/items-json-slot/items-${this.itemSlot}.json`);
        let twoHanded = this.$http.get(`https://www.osrsbox.com/osrsbox-db/items-json-slot/items-2h.json`);

        this.$http.all([oneHanded, twoHanded]).then(this.$http.spread((oneResp, twoResp) => {
          let all = {};

          for (const key of Object.keys(oneResp.data)) {
            all[key] = oneResp.data[key]
          }

          for (const key of Object.keys(twoResp.data)) {
            all[key] = twoResp.data[key];

            all[key].is_two_handed = true;
          }

          this.originalItems = all;
          this.addEmptyItem();


          this.items = this.parsedItems
        }))
      },

      loadBlowpipeAmmo: function() {

      },

      itemNone: function () {
        let none = require('@/assets/data/equipment/none.json');
        none.slot = this.itemSlot;

        return none;
      },

      showItemSearch: function () {
        this.$refs.itemSearch.showSearch();

        // this.showSearch = true;
      },

      hideItemSearch: function () {
        this.$refs.itemSearch.hideSearch();
        // this.showSearch = false;
      },

      addEmptyItem: function () {
        let none = require('@/assets/data/equipment/none.json');
        none.slot = this.itemSlot;
        this.originalItems[0] = none;
      },

      itemSelected: function (item) {
        console.log('item selected', item);
        this.hideItemSearch();

        this.$emit('update', item);
      }
    },
    mounted() {
      this.loadItems();
    }
  }
</script>

<style scoped>
  .item-slot {
    display: block;
    margin-left: auto;
    margin-right: auto;
    cursor: pointer;
  }

  .default {
    /*opacity: 0.2;*/

  }

  .icon-image {
    /*transform: scale(1.4);*/
    height: auto;
    width: 75%;
  }
</style>



// WEBPACK FOOTER //
// src/components/gear-selector/ItemSlot.vue